export const firebaseConfig = {
  apiKey: "AIzaSyATnvoeaFb8cZ6gporVB73tpDR17cJuGyo",
  authDomain: "optometry-clinic-5643a.firebaseapp.com",
  projectId: "optometry-clinic-5643a",
  storageBucket: "optometry-clinic-5643a.firebasestorage.app",
  messagingSenderId: "981562924495",
  appId: "1:981562924495:web:bcb3769965740c10a106ba"
}
